import React, { forwardRef } from 'react';
import { WarningAmberRounded, InfoOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import OtxToast from 'components/shared/toasts/OtxToast';
import AnimatedCheckIcon from 'components/shared/toasts/AnimatedCheckIcon';
import AnimatedErrorIcon from 'components/shared/toasts/AnimatedErrorIcon';

// Pop sobrio para los iconos estáticos (warning/info): mismo timing que el check/X.
const iconPop = keyframes`
  from { transform: scale(0.4); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const popSx = {
  display: 'flex',
  flex: 'none',
  opacity: 0,
  animation: `${iconPop} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
  animationDelay: '100ms'
};

// Variantes registradas en el SnackbarProvider (prop `Components`). notistack pasa
// id/message/action/style/className; aquí solo se decide el icono.
export const ToastSuccess = forwardRef((props, ref) => (
  <OtxToast ref={ref} {...props} icon={<AnimatedCheckIcon />} />
));

export const ToastError = forwardRef((props, ref) => (
  <OtxToast ref={ref} {...props} icon={<AnimatedErrorIcon />} />
));

export const ToastWarning = forwardRef((props, ref) => (
  <OtxToast
    ref={ref}
    {...props}
    icon={
      <Box sx={popSx} aria-hidden>
        <WarningAmberRounded sx={{ fontSize: 20, color: 'gold.main' }} />
      </Box>
    }
  />
));

export const ToastInfo = forwardRef((props, ref) => (
  <OtxToast
    ref={ref}
    {...props}
    icon={
      <Box sx={popSx} aria-hidden>
        <InfoOutlined sx={{ fontSize: 20, color: 'text.secondary' }} />
      </Box>
    }
  />
));

ToastSuccess.displayName = 'ToastSuccess';
ToastError.displayName = 'ToastError';
ToastWarning.displayName = 'ToastWarning';
ToastInfo.displayName = 'ToastInfo';
